import React, { useEffect, useState } from "react";
import { Theme, useTheme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  CircularProgress,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Slider,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Box } from "@mui/system";
import SaveIcon from "@mui/icons-material/Save";
import Clear from "@mui/icons-material/Clear";
import { getSetPriority, savePriority, editPriority, setVolumePeriod } from "src/utils/GetPriority";
import { useLocalStorage } from "../../utils/LocalStorageHook";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import InfoIcon from "@mui/icons-material/Info";

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    divWidth: {
      width: "100%",
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  })
);

export default function AdminSetPriority() {
  const classes = useStyles();
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [state, setState] = useState<any>({});
  //conroll accordions
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [openSnack, setOpenSnack] = useState(false);
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(true);
  const [volPeriod, setVolPeriod] = useState("");
  const [orgVolPeriod, setOrgVolPeriod] = useState("");
  // const [volEdit, setVolEdit] = useState(false);
  const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };
  const noData = {
    A: [],
    B: [],
    C: [],
    D: [],
  };

  useEffect(() => {
    getSetPriority(salesOrg.toString())
      .then((v: any) => {
        setBackdropLoader(false);
        const data = v?.data;
        const respMsg = v?.message;
       // console.log("🚀 ~ file: AdminSetPriority.tsx ~ line 63 ~ getSetPriority ~ data", data, respMsg);
        if (respMsg === "success" && data?.length > 0) {
          const dataFormatted = data?.reduce((result: any, currentValue: any) => {
            (result[currentValue?.category] = result[currentValue?.category] || []).push(currentValue);
            return result;
          }, {});
          const res = {
            A: dataFormatted?.A ?? [],
            B: dataFormatted?.B ?? [],
            C: dataFormatted?.C ?? [],
            D: dataFormatted?.D ?? [],
          };
          setState(res);
        } else {
          setState(noData);
        }
      })
      .catch((err) => {
        setBackdropLoader(false);
        alert("Failed to Load");
       // console.log("🚀 ~ file: AdminSetPriority.tsx ~ line 91 ~ getSetPriority ~ err", err);
      });
  }, []);
  useEffect(() => {
    if (openSnack) {
      let timer1 = setTimeout(() => setOpenSnack(false), 6000);
      return () => {
        clearTimeout(timer1);
      };
    }
  }, [openSnack]);

  const saveSetPriority = (
    category: string,
    machineType: string,
    volume: number,
    // volumePeriod: number,
    driSetting: number,
    visitDaysWithin: string,
    aspd: number,
    edit: boolean
  ) => {
    const volumePeriod = Number(volPeriod);
    const value = state?.A[0];
    const orgPeriod = value?.volumePeriod ?? 52;
    const volEdit = orgPeriod === volumePeriod;
    setBackdropLoader(true);
    if (!edit) {
      savePriority(
        salesOrg,
        category,
        machineType,
        volume,
        volumePeriod,
        driSetting,
        visitDaysWithin,
        aspd,
        volEdit
      ).then((ret) => {
        setState(noData);
        if (ret && ret.message === "saved") {
          getSetPriority(salesOrg.toString())
            .then((v: any) => {
              setBackdropLoader(false);
              const data = v?.data;
              const respMsg = v?.message;
              //console.log("🚀 ~ file: AdminSetPriority.tsx ~ line 63 ~ getSetPriority ~ data", data, respMsg);
              if (respMsg === "success" && data?.length > 0) {
                const dataFormatted = data?.reduce((result: any, currentValue: any) => {
                  (result[currentValue?.category] = result[currentValue?.category] || []).push(currentValue);
                  return result;
                }, {});
                const res = {
                  A: dataFormatted?.A ?? [],
                  B: dataFormatted?.B ?? [],
                  C: dataFormatted?.C ?? [],
                  D: dataFormatted?.D ?? [],
                };
                setState(res);
                // setState(dataFormatted);
              } else {
                setState(noData);
              }
            })
            .catch((err) => {
              setBackdropLoader(false);
              alert("Failed to Save");
            });
        }
      });
    } else {
      editPriority(salesOrg, category, machineType, volume, volumePeriod, driSetting, visitDaysWithin, aspd, volEdit)
        .then((ret) => {
          setState(noData);
          if (ret && ret.message === "saved") {
            getSetPriority(salesOrg.toString())
              .then((v: any) => {
                setBackdropLoader(false);
                const data = v?.data;
                const respMsg = v?.message;
               // console.log("🚀 ~ file: AdminSetPriority.tsx ~ line 63 ~ getSetPriority ~ data", data, respMsg);
                if (respMsg === "success" && data?.length > 0) {
                  const dataFormatted = data?.reduce((result: any, currentValue: any) => {
                    (result[currentValue?.category] = result[currentValue?.category] || []).push(currentValue);
                    return result;
                  }, {});
                  const res = {
                    A: dataFormatted?.A ?? [],
                    B: dataFormatted?.B ?? [],
                    C: dataFormatted?.C ?? [],
                    D: dataFormatted?.D ?? [],
                  };
                  setState(res);
                  // setState(dataFormatted);
                } else {
                  setState(noData);
                }
              })
              .catch((err) => {
               // console.log("🚀 ~ file: AdminSetPriority.tsx ~ line 184 ~ getSetPriority ~ err", err);
                setBackdropLoader(false);
                alert("Failed to update");
              });
          }
        })
        .catch((err) => {
         // console.log("🚀 ~ file: AdminSetPriority.tsx ~ line 184 ~ getSetPriority ~ err", err);
          setBackdropLoader(false);
          alert("Failed to update");
        });
    }
  };

  useEffect(() => {
    if (state?.A?.length > 0) {
      const value = state?.A[0];
      const volPeriod = value?.volumePeriod;
      setVolPeriod(volPeriod);
      setOrgVolPeriod(volPeriod);
    } else {
      setVolPeriod("52");
      setOrgVolPeriod("52");
    }
  }, [state]);

  const handleVolCancel = () => {
    setVolPeriod(orgVolPeriod);
  };

  const handleVolSave = () => {
    // setVolEdit(false);
    if (JSON.stringify(state) === JSON.stringify(noData)) {
      setOpenSnack(true);
      setVolPeriod(orgVolPeriod);
    } else {
      setBackdropLoader(true);
      const volumePeriod = Number(volPeriod);
      setVolumePeriod(salesOrg, volumePeriod).then((ret) => {
        setState(noData);
        if (ret && ret.message === "saved") {
          getSetPriority(salesOrg.toString())
            .then((v: any) => {
              setBackdropLoader(false);
              const data = v?.data;
              const respMsg = v?.message;
              if (respMsg === "success" && data?.length > 0) {
                const dataFormatted = data?.reduce((result: any, currentValue: any) => {
                  (result[currentValue?.category] = result[currentValue?.category] || []).push(currentValue);
                  return result;
                }, {});
                const res = {
                  A: dataFormatted?.A ?? [],
                  B: dataFormatted?.B ?? [],
                  C: dataFormatted?.C ?? [],
                  D: dataFormatted?.D ?? [],
                };
                setState(res);
                // setState(dataFormatted);
              } else {
                setState(noData);
              }
            })
            .catch((err) => {
              setBackdropLoader(false);
              alert("Failed to Save");
            });
        }
      });
    }
  };
  const isVolPeriodModified = orgVolPeriod != volPeriod;
  return (
    <div className={classes.root}>
      <SnackbarComponent open={openSnack} severity="error" desc="Set criteria for atleast one priority " />
      <Typography variant="h4" color="primary" className={classes.paragraph}>
        Set Priority
      </Typography>
      <Box sx={{ padding: "2%" }}>
        <Box sx={{ mb: "16px", display: "flex", flexDirection: "row", alignItems: "baseline" }}>
          <Typography fontSize={20}>
            <sup style={{ color: "red", fontSize: 20 }}>* </sup>
            Priority based on last
          </Typography>
          <TextField
            id="volPeriod"
            value={volPeriod}
            type="number"
            size="small"
            InputProps={{ inputProps: { min: 0, max: 60 } }} 
            onChange={(e) => {
              if (Number(e.target.value) > 0) {
                setVolPeriod(e.target.value);
                // setVolEdit(true);
              }
            }}
            sx={{ width: 50, mx: "8px", fontSize: 20 }}
          />
          <Typography fontSize={20}>
            weeks sales{" "}
            <span style={{ fontSize: "16px", color: "grey" }}>( This will be applied to all the four categories )</span>
          </Typography>
        </Box>
        {isVolPeriodModified && (
          <Box
            sx={{ mb: "6px", display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-end" }}
          >
            <React.Fragment>
              <Tooltip title={"Save"} onClick={handleVolSave}>
                <IconButton color="primary">
                  <SaveIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Cancel"}>
                <IconButton color="primary" onClick={handleVolCancel}>
                  <Clear />
                </IconButton>
              </Tooltip>
            </React.Fragment>
          </Box>
        )}

        {Object.entries(state)?.map(([key, val]: any) => {
          return (
            <Accordion expanded={expanded === key} onChange={handleChange(key)}>
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1bh-content" id="panel1bh-header">
                <Typography sx={{ width: "33%", flexShrink: 0 }}>Category {key}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {val?.map((item: any) => {
                  return (
                    <PriortyFrom title={item?.machineType} state={item} category={key} handleSave={saveSetPriority} />
                  );
                })}
                {val?.length === 1 &&
                  (val[0]?.machineType === "gfv" ? (
                    <PriortyFrom title={"stack"} state={null} category={key} handleSave={saveSetPriority} />
                  ) : (
                    <PriortyFrom title={"gfv"} state={null} category={key} handleSave={saveSetPriority} />
                  ))}
                {val?.length === 0 && (
                  <>
                    <PriortyFrom title={"gfv"} state={null} category={key} handleSave={saveSetPriority} />
                    <PriortyFrom title={"stack"} state={null} category={key} handleSave={saveSetPriority} />
                  </>
                )}
              </AccordionDetails>
            </Accordion>
          );
        })}
        <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={backdropLoader}>
          <CircularProgress color="primary" />
        </Backdrop>
      </Box>
    </div>
  );
}

// snackbar
const SnackbarComponent = (props: any) => {
  const { open, severity, desc } = props;
  return (
    <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={open} autoHideDuration={6000}>
      <Alert severity={severity} sx={{ width: "500px" }}>
        {desc}
      </Alert>
    </Snackbar>
  );
};

// Accordion body
const PriortyFrom = (props: any) => {
  const { title, state, category, handleSave } = props;
 // console.log("🚀 ~ file: AdminSetPriority.tsx ~ line 172 ~ PriortyFrom ~ state", props);
  //* input values
  // aspd: 10;
  // category: "A";
  // clientId: "100";
  // driSetting: 5;
  // machineType: "gfv";
  // salesOrg: "4100";
  // visitDays: (2)[(0, 2)];
  // volCs: 120;
  // volPeriod: 52;
  const stateFull = {
    aspd: state?.aspd,
    driSetting: state?.driSetting,
    visitDays: state?.visitDaysWithin,
    volCs: state?.volume,
  };
  const nullState = {
    aspd: 0,
    driSetting: 0,
    visitDays: [0, 0],
    volCs: 0,
  };
  const initialInputVal = state !== null ? stateFull : nullState;
  const [inputValues, setInputValues] = useState(initialInputVal);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    if (state !== null) {
      setIsEdit(true);
    }
  }, []);

  const handleVisitChange = (event: Event, newValue: number | number[]) => {
    setInputValues({ ...inputValues, visitDays: newValue as number[] });
  };
  function valuetext(value: number) {
    return `${value}°C`;
  }
  const noChange = JSON.stringify(initialInputVal) === JSON.stringify(inputValues);
  //console.log(inputValues?.aspd);
  const disabledSaveButton =
    noChange ||
    !parseInt(inputValues?.volCs) || !parseInt(inputValues?.driSetting) || parseInt(inputValues?.volCs) < 1 ||
    inputValues?.aspd === '' ||
    inputValues?.visitDays.join(",") === "0,0";
  const handlePrioritySave = () => {
    const cat: string = category;
    const machineType: string = title;
    const volume: number = parseInt(inputValues?.volCs);
    const driSetting: number = parseInt(inputValues?.driSetting);
    const visitDaysWithin: string = inputValues?.visitDays.join(",");
    const aspd: number = parseInt(inputValues?.aspd);
    const edit: boolean = isEdit;
    handleSave(cat, machineType, volume, driSetting, visitDaysWithin, aspd, edit);
  };

  return (
    <Box sx={{ mb: "20px" }}>
      <Typography variant="h4" sx={{ fontSize: "24px", textTransform: "uppercase" }}>
        {title}
      </Typography>
      <Grid container spacing={4} alignItems="center" justifyContent="start" sx={{ px: "10px", mt: "12px" }}>
        <Grid item>
          <InputLabel color="primary" sx={{ pb: "10px", textTransform: "uppercase", color: "primary" }}>
            Visit days within
          </InputLabel>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            <Slider
              sx={{ width: 200, mr: "12px" }}
              getAriaLabel={() => "visit days range"}
              value={inputValues.visitDays}
              onChange={handleVisitChange}
              valueLabelDisplay="auto"
              getAriaValueText={valuetext}
              min={1}
              max={100}
            />
            <Typography>{`(${inputValues?.visitDays[0]} - ${inputValues?.visitDays[1]} days )`}</Typography>
          </Box>
        </Grid>
        <Grid item>
          <InputLabel color="primary" sx={{ textTransform: "uppercase" }}>
            DRI
          </InputLabel>
          <Box sx={{ m: 1 }}>
            <TextField
              id="dri_setting"
              value={inputValues.driSetting}
              type="number"
              size="small"
              onChange={(e) => {
                if (Number(e.target.value) >= 0) setInputValues({ ...inputValues, driSetting: e.target.value });
              }}
              sx={{ width: 50 }}
            />
          </Box>
        </Grid>
        <Grid item>
          <InputLabel color="primary" sx={{ textTransform: "uppercase" }}>
            Volume
          </InputLabel>
          <Box sx={{ width: "500", display: "flex", flexDirection: "row", m: 1, alignItems: "center" }}>
            <TextField
              id="volume"
              value={inputValues.volCs}
              type="number"
              sx={{ width: 70, mx: "6px" }}
              onChange={(e) => {
                if (Number(e.target.value) >= 0) setInputValues({ ...inputValues, volCs: e.target.value });
              }}
            />
            <Typography>cs</Typography>
            {/* <TextField
              id="volume_range"
              value={inputValues.volPeriod}
              type="number"
              sx={{ width: 60, mx: "10px", textAlign: "center" }}
              onChange={(e) => {
                if (Number(e.target.value) >= 0) setInputValues({ ...inputValues, volPeriod: e.target.value });
              }}
            />
            <Typography>weeks</Typography> */}
          </Box>
        </Grid>
        <Grid item>
          <InputLabel color="primary" sx={{ textTransform: "uppercase" }}>
            ASPD (cases)
          </InputLabel>
          <Box>
            <TextField
              id="avg_sales_per_day"
              value={inputValues.aspd}
              type="number"
              onChange={(e) => {
                if (Number(e.target.value) >= 0) setInputValues({ ...inputValues, aspd: e.target.value });
              }}
            />
          </Box>
        </Grid>
        <Grid item lg={12} alignItems="end">
          <div style={{ paddingRight: "5px", textAlign: "right" }}>
            <React.Fragment>
              <Tooltip title={"Save"}>
                <IconButton onClick={handlePrioritySave} color="primary" disabled={disabledSaveButton}>
                  <SaveIcon />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Cancel"}>
                <IconButton color="primary" disabled={noChange} onClick={() => setInputValues(initialInputVal)}>
                  <Clear />
                </IconButton>
              </Tooltip>
            </React.Fragment>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
};
